import React from 'react';
import Link from 'react-router/lib/Link';
import CSSModules from 'react-css-modules';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';

import { selectPendingDependentAssignmentsCounter } from '../../../redux/data/selectors';
import { APP_NOTIFICATIONS } from '../../../constants/routes';
import { IDS } from '../../../constants/ids';
import Icon from '../../Icon';
import styles from '../index.styl';

const AppNotificationsBtn = ({ isProvider }) => {
  const count = useSelector(selectPendingDependentAssignmentsCounter);

  if (!isProvider) return null;

  return (
    <div styleName="item">
      <Link
        id={IDS.NAV_BAR.APP_NOTIFICATIONS_LINK}
        to={APP_NOTIFICATIONS}
        className="ph3"
        styleName="link"
      >
        <div styleName={cn({ 'unread-icon': count > 0 })}>
          <Icon name="notification-ring" size={36} />
        </div>
      </Link>
    </div>
  );
};

AppNotificationsBtn.propTypes = {
  isProvider: PropTypes.bool,
};

export default CSSModules(AppNotificationsBtn, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/Header/Components/AppNotificationsBtn.jsx